export default {
  title: {
    id: 'bo_sellers-opportunities-pricing-quick_wins-title',
    defaultMessage: 'Quick wins',
  },
  subtitle: {
    id: 'bo_sellers-opportunities-pricing-quick_wins-subtitle',
    defaultMessage: 'Win these BackBoxes by dropping your prices a little.',
  },
  info: {
    id: 'bo_sellers-opportunities-pricing-quick_wins-info',
    defaultMessage:
      'Win {count} BackBoxes by decreasing your prices by an average of {percentage}%',
  },
  success: {
    id: 'bo_sellers-opportunities-pricing-quick_wins-success',
    defaultMessage: 'Nice work. Your items are priced to sell.',
  },
  fetchingData: {
    id: 'bo_sellers-opportunities-pricing-quick_wins-fetching_data',
    defaultMessage: 'Fetching opportunities',
  },
  saveTime: {
    id: 'bo_sellers-opportunities-pricing-quick_wins-save_time',
    defaultMessage: 'And save time by winning all of these BackBoxes at once.',
  },
  items: {
    id: 'bo_sellers-opportunities-pricing-quick_wins_items',
    defaultMessage: `{count, plural,
      =0 {0 item}
      one {# item}
      other {# items}
    }`,
  },
}
